import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/notfound'
  },
  {
    path: '/expired',
    name: 'expired',
    component: () => import('../views/TransactionExpired.vue')
  },
  {
    path: '/notfound',
    name: 'notfound',
    component: () => import('../views/TransactionNotFound.vue')
  },
  {
    path: '/paid',
    name: 'paid',
    component: () => import('../views/TransactionPaid.vue')
  },
  {
    path: '/pix/:transactionId',
    component: () => import('../views/Payment.vue')
  },
  {
    path: '/:transactionId',
    component: () => import('../views/Payment.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
